(function () {
    (data.forms).forEach(form => {
        let url = 'https://forms.hypotheekonline.nl/'
        if (data.params.test && data.params.test === 1) {
            url = 'http://127.0.0.1:8000/'
        }
        const config = {
            nodeId: 'form-' + form,
            width: '100%',
            height: '100%',
            url: url + '?form=' + form,
            /* events: {
                loaded: function () {},
                started: function (data) {},
                completed: function (data) {},
                exception: function (data) {}
            }, */
            data: data.params
        };
        const dataQueryString = config.data ? Object.keys(config.data)
        .map(function (key) {
            return '&' + key + '=' + encodeURIComponent(config.data[key]);
        })
        .join('') : '';
        
        const iframe = document.createElement('iframe');
        iframe.src = config.url + dataQueryString;
        iframe.allowtransparency = true;
        iframe.style = "border: none"
    
        if (config.nodeId) {
            const node = document.getElementById(config.nodeId);
            if (node) {
                node.style.height = config.height;
                node.style.width = config.width;
                iframe.height = '100%';
                iframe.width = '100%';
                node.append(iframe);
            }
        } else {
            iframe.height = config.height;
            iframe.width = config.width;
            document.body.append(iframe);
        }
        window.addEventListener('message', function (e) {
            let formData = e.data
            if (formData && formData != 'success') {
                formData = JSON.parse(formData)
                if (typeof formData[form] !== 'undefined') {
                    this.document.getElementById('form-' + form).style.height = formData[form] + 'px'
                    console.log('height of form ' + form + ' is ' + formData[form]);
                }
            }
        });
    });
    window.addEventListener('message', function (e) {
        const data = e.data
        if (data && data == 'success') {
            location.href = '/bedankt?form=complete';
            /* var google_conversion_id = 838941207;
            var google_conversion_label = "kzkwCKDK534Ql_SEkAM"; 
            var google_remarketing_only = false;

            var js_script = document.createElement('script');
            js_script.type = "text/javascript";
            js_script.src = "//www.googleadservices.com/pagead/conversion.js";
            js_script.async = true;
            document.getElementsByTagName('head')[0].appendChild(js_script);
     
            var image = new Image(1, 1);
            image.src = "//www.googleadservices.com/pagead/conversion/838941207/?label=kzkwCKDK534Ql_SEkAM&amp;guid=ON&amp;script=0"; */
        }
    });
})();